import React from "react";
import { FaWhatsapp } from "react-icons/fa";

export const SingleWhatsappTemplateRow = ({ props }: any) => {
  const { name, body } = props;

  return (
    <tr>
      <td>{name}</td>
      <td>{body}</td>
      <td>
      <div>
                <span title="Whatsapp notification">
                  <FaWhatsapp
                    className="button-icon disabledButton"
                    // onClick={() => {
                    //   setModal("confirmnotification");
                    //   onOpen();
                    // }}
                  />
                </span>
              </div>
      </td>
    </tr>
  );
};
